import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  MDBFooter,
  MDBContainer,
} from 'mdb-react-ui-kit';

import { FaFacebook, FaTwitter, FaGoogle, FaInstagram, FaLinkedin, FaGithub } from 'react-icons/fa';
import '../css/Footer.css';


const Footer = () => {
    const [email, setEmail] = useState('');

    const handleSubscribe = () => {
      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  
      if (email && emailRegex.test(email)) {
        toast.success(`🎉 You have subscribed to our newsletter`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'colored',
        });
        setEmail('');
      } else {
        toast.error('Please enter a valid email address to subscribe.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'colored',
        });
      }
    };


    return (
        <div className="footer-div">
      <MDBFooter className="bg-dark text-center text-white">
        <MDBContainer className="">
          <section className="footer-content">
            <div className="left-section">
              <div className="text-left">
                © 2023 Copyright:
                <span className="text-white">
                        Team@
                </span>
              </div>
            </div>
            <div className="middle-section">
              <a href="https://www.facebook.com" className="m-1" role="button">
                <FaFacebook />
              </a>
              <a href="https://www.twitter.com" className="m-1" role="button">
                <FaTwitter />
              </a>
              <a href="https://www.google.com" className="m-1" role="button">
                <FaGoogle />
              </a>
              <a href="https://www.instagram.com" className="m-1" role="button">
                <FaInstagram />
              </a>
              <a href="https://www.linkedin.com" className="m-1" role="button">
                <FaLinkedin />
              </a>
              <a href="https://www.github.com" className="m-1" role="button">
                <FaGithub />
              </a>
            </div>
            <div className="right-section">
              <div className="subscribe-newsletter">
                <input
                  type="text"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button onClick={handleSubscribe}>Subscribe</button>
              </div>
            </div>
          </section>
        </MDBContainer>
      </MDBFooter>

<ToastContainer
  className="custom-toast-container"  // Add this line
  position="top-right"
  autoClose={5000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover
  theme="colored"
/>

    </div>
  );
}
export default Footer;